import React, { Component } from 'react';
import { Router, Route } from "react-router-dom";
import history from './utils/configureRouteHistory';

import '../node_modules/react-vis/dist/style.css';

import {StripeProvider} from 'react-stripe-elements';
import LoginPage from './page/login/login_page';
import IndexPage from './page/employee/index_page';
import RegisterPage from './page/register/register_page';
import ResetPasswordPage from './page/reset_password/reset_password_page';
import ForgetPasswordPage from './page/forget_password/forget_password_page';
import SysadminIndexPage from './page/sysadmin/index_page';
import HradminIndexPage from './page/hradmin/index_page';
import AdminRedirectPage from './page/sso/admin_redirect_page';
import RecoverAccountPage from './page/recover_account/index';
import AdminRegisterPassword from './page/sysadmin/admin_register_password';

class App extends Component {
  
  constructor() {
    super();
    this.state = {stripe: null};
  }
  componentDidMount() {
    if (window.Stripe) {
      this.setState({stripe: window.Stripe('pk_test_12345')});
    } else {
      document.querySelector('#stripe-js').addEventListener('load', () => {
        // Create Stripe instance once Stripe.js loads
        this.setState({stripe: window.Stripe('pk_test_12345')});
      });
    }
  }

  componentWillMount(){
    if(history.location.pathname !== '/' &&
      history.location.pathname.startsWith('/app') &&
      history.location.pathname.startsWith('/systemadmin') &&
      history.location.pathname.startsWith('/hradmin')
      ){
      history.push('/?redirect='+history.location.pathname)
    }
  }

  render() {
    return (
      <StripeProvider stripe={this.state.stripe}>
        <Router history={history}>
          <div>
            <Route exact path="/" component={LoginPage} />
            <Route path="/register" component={RegisterPage} />
            <Route path="/resetpassword/:tokenId" component={ResetPasswordPage} />
            <Route path="/forgetpassword" component={ForgetPasswordPage} />
            <Route path="/app" component={IndexPage} />
            <Route path="/systemadmin" component={SysadminIndexPage} />
            <Route path="/hradmin" component={HradminIndexPage} />
            <Route path="/redirect_login" component={AdminRedirectPage} />
            <Route path="/recoverAccount" component={RecoverAccountPage} />
            <Route path="/registeradmin/:activationId?" component={AdminRegisterPassword} />
          </div>
        </Router>
      </StripeProvider>
    );
  }
}

export default App;